<script>
  import {timeDifference} from '../../utils/formatter.js'

  export default {
    mounted () {
      this.interval = window.setInterval(() => {
        this.difference = timeDifference(Date.now(), this.time)
      }, 5000)
    },
    beforeDestroy () {
      window.clearInterval(this.interval)
      this.interval = null
    },
    data () {
      return {
        difference: timeDifference(Date.now(), this.time),
      }
    },
    computed: {
      displayString () {
        return this.$tc('timediff.' + this.difference.type, this.difference[this.difference.type])
      }
    },
    props: {
      time: Date
    }
  }
</script>
<template>
  <span>{{displayString}}</span>
</template>
